import { useRoute } from '@react-navigation/native';
import React from 'react';
import { Pressable, StatusBar } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

import BackMobileIcon from '@/assets/images/level-detail/back-mobile.svg';
import { Scroll, Stack } from '@/components/layout';
import { LevelDetailPanel } from '@/features/guardian-player/components/level-detail';
import { createStyles, useGuardianStackNavigation, useScaling } from '@/hooks';
import type { GuardianStackScreenProps } from '@/navigations/types';
import { colors, guardianColors } from '@/theme/colors';

type SkillDetailRoute = GuardianStackScreenProps<'GuardianPlayerSkillDetail'>['route'];

export function GuardianPlayerSkillDetailScreen() {
  const route = useRoute<SkillDetailRoute>();
  const navigation = useGuardianStackNavigation();
  const styles = useStyles();
  const { scale } = useScaling();
  const insets = useSafeAreaInsets();
  const { pin } = route.params;

  const handleBackPress = () => {
    if (navigation.canGoBack()) {
      navigation.goBack();
      return;
    }
    navigation.navigate('GuardianDashboard');
  };

  return (
    <Stack flex={1} backgroundColor={guardianColors['1']}>
      <StatusBar barStyle="dark-content" backgroundColor="transparent" translucent />
      <LinearGradient
        colors={['#EEF3FF', guardianColors['1'], '#EEF3FF']}
        locations={[0.08, 0.47, 0.9]}
        useAngle
        angle={210.65}
        style={styles.gradient}>
        <Stack
          direction="row"
          align="center"
          justify="space-between"
          style={[
            styles.header,
            {
              paddingTop: insets.top + scale(12),
            },
          ]}>
          <Pressable accessibilityRole="button" onPress={handleBackPress} style={styles.iconButton}>
            <BackMobileIcon width={scale(24)} height={scale(24)} />
          </Pressable>
          <Stack style={styles.iconButtonGhost} />
        </Stack>
        <Scroll showsVerticalScrollIndicator={false} contentContainerStyle={styles.scrollContent}>
          <LevelDetailPanel pin={pin} standalone />
        </Scroll>
      </LinearGradient>
    </Stack>
  );
}

const useStyles = createStyles(({ scale }) => ({
  gradient: {
    flex: 1,
  },
  header: {
    minHeight: scale(92),
    paddingHorizontal: scale(24),
    paddingBottom: scale(12),
  },
  iconButton: {
    width: scale(40),
    height: scale(40),
    borderRadius: scale(20),
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: colors['0'],
    shadowColor: guardianColors['10'],
    shadowOpacity: 0.06,
    shadowOffset: { width: 0, height: scale(2) },
    shadowRadius: scale(6),
    elevation: 1,
  },
  iconButtonGhost: {
    width: scale(48),
    height: scale(48),
  },
  scrollContent: {
    paddingBottom: scale(24),
  },
}));
